import { ReportDetailDTO, ReportsBrowseDTO } from '@/services/api/reportsV2';
import { ReportDetail, ReportsBrowse, ReportSummary } from './types';

export const mapReportSummary = (value: ReportsBrowseDTO['data'][number]): ReportSummary => ({
  ...value,
  medicalStatus: (value.medicalStatus || '') as ReportSummary['medicalStatus'],
  medicalSeverity: (value.medicalSeverity || '') as ReportSummary['medicalSeverity'],
});

export const mapReportsBrowse = (value: ReportsBrowseDTO): ReportsBrowse => ({
  data: value.data.map(mapReportSummary),
  meta: { page: value.meta.page, pageSize: value.meta.page_size, total: value.meta.total, totalPages: value.meta.total_pages },
  facets: value.facets,
  capabilities: value.capabilities,
});

export const mapReportDetail = (value: ReportDetailDTO): ReportDetail => ({ ...value });
